import { ToWords } from "to-words";

export const toWords = new ToWords({
  localeCode: "fr-FR",
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
    currencyOptions: {
      // can be used to override defaults for the selected locale
      name: "Dinar Algerien",
      plural: "Dinars Algeriens",
      symbol: "DZD",
      fractionalUnit: {
        name: "Centime",
        plural: "Centimes",
        symbol: "",
      },
    },
  },
});
